import { Theme } from '@src/types/enum';
import type { LitElement } from 'lit';
import { createCustomerAttributeInteraction } from '@common/customerAttributes/createCustomerAttributeInteraction';
import type { TefComsCustomerAttribute } from '@src/components/tef-coms-customer-attribute';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs';
import { comsStore } from '@src/state/ComsStore';

type Constructor<T = object> = new (...args: any[]) => T; // eslint-disable-line @typescript-eslint/no-explicit-any

type ReplaceElementCompatibleTypes = TefComs4csMicroFrontend | TefComsCustomerAttribute;

export declare class ReplaceElementsMixinI {
  replaceElementsInNode(targetElement?: HTMLElement): void;
}

/**
 * A mixin that replaces relevant DOM parts with templates rendered using the current theme (occl/tefOne)
 * There are two variantes of "replaceElements" elements here:
 * - replaceElements which is used in the templates
 * - replaceElementsInNode which is user in customer attributes
 *
 * TODO: remove replaceElements and replace with updated replaceElementsInNode (VERY complicated because of signature!) (FS, 09.11.2025)
 */
export const ReplaceElementsMixin = <T extends Constructor<LitElement>>(superClass: T) => {
  class ReplaceElementsMixinClass extends superClass {
    replaceElementsInNode(this: ReplaceElementCompatibleTypes, targetElement?: HTMLElement) {
      const { styleContext, occlUri } = comsStore.config!;
      const isOcclTheme = !!occlUri;
      this.setTemplatingTheme(isOcclTheme ? Theme.OCCL : Theme.TEFONE);

      const target = targetElement || this.shadowRoot || this;

      createCustomerAttributeInteraction(target);

      // In tef-coms4cs we need to call the underlying template function with the title and description seperately :(
      this.createTooltipInteraction(target, styleContext || '', true);

      if (!isOcclTheme) {
        this.replaceElementsWithTpl(target, 'emTemplate', 'em');
        this.replaceElementsWithTpl(target, 'comsP1Template', 'div.coms-paragraph-1');
        this.replaceElementsWithTpl(target, 'linkTemplate', 'a');
      }
    }
  }
  return ReplaceElementsMixinClass as Constructor<ReplaceElementsMixinI> & T;
};
